/**
 * @generated SignedSource<<5e9aa7e9d30e64987b1d175b9175f05c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RepositoryPickerRepository$data = {
  readonly codeOfConductFileUrl: string | null;
  readonly contributingFileUrl: string | null;
  readonly databaseId: number | null;
  readonly hasIssuesEnabled: boolean;
  readonly id: string;
  readonly isArchived: boolean;
  readonly isInOrganization: boolean;
  readonly isPrivate: boolean;
  readonly issueTypes: {
    readonly __typename: "IssueTypeConnection";
  } | null;
  readonly name: string;
  readonly nameWithOwner: string;
  readonly owner: {
    readonly avatarUrl: string;
    readonly login: string;
  };
  readonly securityPolicyUrl: string | null;
  readonly shortDescriptionHTML: string;
  readonly slashCommandsEnabled: boolean;
  readonly viewerCanPush: boolean;
  readonly viewerIssueCreationPermissions: {
    readonly assignable: boolean;
    readonly labelable: boolean;
    readonly milestoneable: boolean;
    readonly triageable: boolean;
  };
  readonly " $fragmentType": "RepositoryPickerRepository";
};
export type RepositoryPickerRepository$key = {
  readonly " $data"?: RepositoryPickerRepository$data;
  readonly " $fragmentSpreads": FragmentRefs<"RepositoryPickerRepository">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "RepositoryPickerRepository"
};

(node as any).hash = "e1a5e7904d04e202c5c7386c32e0992d";

export default node;
